import { DateTimeFormat } from '@billy/design-system'
import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import { getCurrentLocale } from '../../../../../../../../utils/getCurrentLocale'
import { getLocalDateFromDateString } from '../../../../../../../../utils/getLocalDateFromDateString'
import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'
import { TotalBalanceRow } from '../TotalBalanceRow'

interface PeriodTotalsFootProps {
  closingBalance: number
  columns: LedgerEntryColumnDef[]
  periodEndDate?: string
  periodMovement: number
}

export const PeriodTotalsFoot = ({
  closingBalance,
  columns,
  periodEndDate,
  periodMovement,
}: PeriodTotalsFootProps): ReactElement => {
  const { bt } = useBalanceLabels()
  const closingBalanceLabel = periodEndDate
    ? bt('detail_view.closing_balance.label', {
        date: DateTimeFormat.getFormattedDate(getLocalDateFromDateString(periodEndDate), getCurrentLocale()),
      })
    : bt('detail_view.closing_balance.label_undated')

  return (
    <Table.Foot>
      <TotalBalanceRow
        columns={columns}
        label={bt('detail_view.period_movement.label')}
        totalBalance={periodMovement}
      />
      <TotalBalanceRow columns={columns} label={closingBalanceLabel} totalBalance={closingBalance} />
    </Table.Foot>
  )
}
